import React from "react";
import { Skeleton } from "antd";

import "./ListLoader.scss";

// Placeholder rows shown while a search list loads: keeps the page height
// stable and signals "loading" more clearly than a lone spinner.
const ListLoader = ({ rows = 4 }) => (
  <div className="listLoader" aria-busy="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div className="listLoader__row" key={i}>
        <Skeleton active avatar={{ shape: "square", size: 64 }} paragraph={{ rows: 2 }} />
      </div>
    ))}
  </div>
);

export default ListLoader;
